import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateOverlay } from '../api';
import { OverlayForm } from '../components';
import { OverlayFormValues } from '../validations';

export const NewOverlayPage: FC = () => {
  const navigate = useNavigate();

  const { createOverlayMutation, uploadUrlDataMutation } = useCreateOverlay();

  const saveOverlay = async (values: OverlayFormValues) => {
    try {
      const { overlayId } = await uploadUrlDataMutation.mutateAsync({
        file: values.imagePublicUrl as File,
      });

      await createOverlayMutation.mutateAsync({
        id: overlayId,
        name: values.name,
      });
      navigate(Routes.Overlays, { replace: true });
      toast.success(`Overlay “${values.name}” added successfully!`);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <OverlayForm onSubmit={saveOverlay}>
      <PageHeader
        title="New Overlay"
        asChildPage
        backPath={Routes.Overlays}
        actions={[
          <Button
            key="create-overlay"
            type="submit"
            data-testid="create-overlay-button"
            isLoading={
              createOverlayMutation.isPending || uploadUrlDataMutation.isPending
            }
            startIcon={<PlusSquareIcon />}
          >
            Create new overlay
          </Button>,
        ]}
      />
    </OverlayForm>
  );
};
